import React from 'react';
import ReactDOM from 'react-dom'; // Untuk React 16, pastikan ini bukan 'react-dom/client'
import App from './App';

ReactDOM.render(<App />, document.getElementById('root'));
